import { FormControl, FormField, FormItem } from "@/src/components/ui/form";
import { FiltersFormT } from "./filters.schema";
import { Combobox } from "../../../components/ui/combobox";
import { fetch } from "../../../lib/fetch";

type Customer = {
  email: string;
  firstName: string;
  lastName: string;
  fullName: string;
};

export const Customer = () => {
  return (
    <div>
      <h3 className="text-lg font-semibold col-span-full mb-4">Customer</h3>
      <FormField<FiltersFormT, "customer">
        name="customer"
        render={({ field }) => {
          return (
            <FormItem>
              <FormControl>
                <Combobox
                  className="flex w-96"
                  loadOptions={(query) => {
                    const data = fetch<{ data: Customer[]; success: boolean }>(
                      `/api/users/customers-with-bookings?${query ? `&filter=${query}` : ""}&pageSize=30`,
                    ).then((r) => {
                      return r.data;
                    });
                    return data;
                  }}
                  placeholder="Search for customer..."
                  value={field.value}
                  onChange={(v) => {
                    if (field.value?.email !== v?.email) {
                      field.onChange(v);
                    } else {
                      field.onChange(null);
                    }
                  }}
                  renderOption={(r) => {
                    return r.firstName
                      ? `${r.firstName === null ? "" : r.firstName} ${r.lastName === null ? "" : r.lastName} (${r.email})`
                      : r.fullName
                        ? `${r.fullName} (${r.email})`
                        : r.email;
                  }}
                />
              </FormControl>
            </FormItem>
          );
        }}
      />
    </div>
  );
};
